import { useTranslation } from "react-i18next";
import type { FC } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";

const WhyChoose: FC = () => {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-7 sm:px-6 lg:px-4 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-0 items-center">

        {/* LEFT IMAGE */}
        <div className="relative flex justify-center lg:justify-start order-2 lg:order-1">
          {/* accent bar - hidden on mobile, visible on lg */}
          <span className="hidden lg:block absolute -left-3 top-12 h-[480px] w-2 bg-[#7EDE56] rounded-full"></span>

          <img
            src="/why-choose.webp" /* convert source file to webp */
            alt="Farmer working in greenhouse"
            loading="lazy"
            className="rounded-2xl w-full sm:w-[400px] md:w-[450px] lg:w-[480px] h-[300px] sm:h-[500px] md:h-[550px] lg:h-[600px] object-cover shadow-xl"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="order-1 lg:order-2">
          <span className="text-[#39841A] font-semibold text-base sm:text-lg mb-2 sm:mb-3 inline-block">
            {t("why_subtitle")}
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#002F3F] mb-3 sm:mb-4 leading-tight">
            {t("why_title")}
          </h2>

          <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6 leading-relaxed max-w-xl">
            {t("why_text")}
          </p>

          {/* FEATURES */}
          <div className="space-y-4 sm:space-y-5 max-w-md">
            {[
              {
                title: t("why_feature_local"),
                desc: t("why_feature_local_desc"),
              },
              {
                title: t("why_feature_custom"),
                desc: t("why_feature_custom_desc"),
              },
              {
                title: t("why_feature_reliable"),
                desc: t("why_feature_reliable_desc"),
              },
            ].map((item, i) => (
              <div key={i} className="flex gap-3 sm:gap-4 items-start">
                <span className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#7EDE56] text-[#002F3F] flex-shrink-0">
                  <FaCheck className="text-sm sm:text-base" />
                </span>
                <div>
                  <h1 className="font-semibold text-base sm:text-lg text-[#002F3F] mb-1">
                    {item.title}
                  </h1>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* BUTTON */}
          <Link
            to="/automation-detail"
            aria-label="Automation solutions details"
            className="mt-6 sm:mt-8 lg:mt-5 inline-flex items-center justify-center bg-[#7EDE56] hover:bg-[#002F3F] transition text-[#002F3F] hover:text-white font-medium px-8 sm:px-10 py-3 sm:py-3 rounded-lg text-sm sm:text-base w-full sm:w-auto"
          >
            {t("why_cta")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;